import { StarIcon } from 'lucide-react';

import { cn } from '@/lib/utils';

type Props = { value: number; variant?: 'user' | 'ai' };

const STARS = [0, 1, 2, 3, 4];

const FILLED_CLASSES: Record<'user' | 'ai', string> = {
  user: 'fill-primary text-primary',
  ai: 'fill-ai text-ai',
};

/** Five-star rating display. Stars below `value` render filled. */
export const StarRating = ({ value, variant = 'user' }: Props) => {
  return (
    <div role="img" aria-label={`${value}/${STARS.length}`} className="flex items-center gap-0.5">
      {STARS.map((index) => (
        <StarIcon
          key={index}
          size={16}
          className={cn(index < value ? FILLED_CLASSES[variant] : 'fill-border text-border')}
        />
      ))}
    </div>
  );
};
